import { styled } from '@mui/material'
import InputAmount from 'components/InputAmount'
import { memo } from 'react'
import { StyledControlInput } from '../../styles/Control'

export const QuoteSymbol = styled('div')`
  font-size: 12px;
  color: ${(props) => props.theme.color.text40};
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

export const StopPriceInput = memo<{
  currentPrice: string
  onChangePrice: (price: string) => void
}>(({ currentPrice, onChangePrice }) => {
  currentPrice = currentPrice ?? ''

  return (
    <StyledControlInput>
      <InputAmount
        value={currentPrice}
        placeholder={'Stop Price'}
        onInput={onChangePrice}
      />
      <div className='input-border' />
      <QuoteSymbol>Last</QuoteSymbol>
    </StyledControlInput>
  )
})
